import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Card } from '../ui';

export const LEVELS = { 1: 'Normale prudenza', 2: 'Massima prudenza', 3: 'Viaggi non essenziali sconsigliati', 4: 'Viaggi sconsigliati' };
export const LEVEL_COLORS = { 1: '#2E9E6A', 2: '#C9A227', 3: '#D9772B', 4: '#C2423A' };
export const NONE = '#2A2F36';
export const scoreColor = (s) => (s == null ? '#8A8F97' : s >= 7 ? '#2E9E6A' : s >= 5 ? '#C9A227' : '#C2423A');
export const DOC_URL = '/docs/BOND_Travel_Security_PMI_Obblighi_di_legge.pdf';

export function ScoreBadge({ score }) {
  return <span className="inline-grid place-items-center w-10 h-7 rounded-sm text-xs font-bold text-white shrink-0" style={{ background: scoreColor(score) }}>{score ?? '–'}</span>;
}

export function TFlag({ iso2, className = 'w-6 h-4' }) {
  if (!iso2) return <span className={`${className} inline-block rounded-[2px] bg-[#2A2F36] shrink-0`} />;
  return <img src={`/flags/${iso2.toUpperCase()}.svg`} alt="" loading="lazy" className={`${className} object-cover rounded-[2px] shrink-0 shadow-sm`} onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }} />;
}

export function LevelChip({ level, short = false }) {
  const c = LEVEL_COLORS[level] || NONE;
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold px-2 py-0.5 rounded-sm whitespace-nowrap" style={{ color: c, background: `${c}1A`, border: `1px solid ${c}55` }}>
      <i className="w-1.5 h-1.5 rounded-full" style={{ background: c }} />{short ? `Livello ${level || '–'}` : LEVELS[level] || 'n.d.'}
    </span>
  );
}

export function CountryRow({ c, onOpen }) {
  return (
    <button onClick={() => onOpen(c.iso3)} className="w-full grid grid-cols-[28px_minmax(0,1fr)_auto_40px_14px] gap-3 items-center py-2.5 px-2 border-t border-[#1F242C] text-left hover:bg-[#D4AF37]/5 transition-colors" data-testid={`travel-country-${c.iso3}`}>
      <TFlag iso2={c.iso2} />
      <span className="text-sm text-[#F2F2F2] truncate" title={c.name}>{c.name}{c.news > 0 && <span className="ml-2 text-[10px] px-1.5 py-0.5 rounded-sm bg-[#C2423A] text-white">{c.news}</span>}</span>
      <span className="hidden sm:block"><LevelChip level={c.farnesina_level} /></span>
      <ScoreBadge score={c.score == null ? null : Math.round(c.score)} />
      <ChevronRight size={14} className="text-[#5A5F67]" />
    </button>
  );
}

export function CountryTile({ c, onOpen }) {
  const col = LEVEL_COLORS[c.farnesina_level] || NONE;
  return (
    <button onClick={() => onOpen(c.iso3)} className="text-left bg-[#0B0D10] border border-[#1F242C] rounded-sm overflow-hidden hover:-translate-y-0.5 hover:border-[#D4AF37]/60 transition-[transform,border-color] duration-200" data-testid={`travel-tile-${c.iso3}`}>
      <div className="h-1" style={{ background: col }} />
      <div className="p-4">
        <div className="flex items-start justify-between gap-2 mb-3"><TFlag iso2={c.iso2} className="w-10 h-7" /><ScoreBadge score={c.score == null ? null : Math.round(c.score)} /></div>
        <p className="text-sm font-semibold text-[#F2F2F2] leading-snug mb-2">{c.name}</p>
        <LevelChip level={c.farnesina_level} />
        {c.news > 0 && <p className="text-[11px] text-[#E37A72] mt-2">{c.news} avvisi ultima ora</p>}
      </div>
    </button>
  );
}

export function NewsFeed({ news, max = 8 }) {
  return (
    <Card className="p-6" data-testid="travel-news">
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#D4AF37] mb-4">Ultima ora · Viaggiare Sicuri</p>
      {news.length === 0 && <p className="text-sm text-[#8A8F97]">Nessun avviso nelle ultime ore.</p>}
      {news.slice(0, max).map((n) => (
        <div key={n.id} className="py-3 border-t border-[#1F242C] first:border-0" data-testid={`travel-news-${n.id}`}>
          <p className="text-sm font-semibold text-[#F2F2F2]">{n.title}</p>
          <div className="text-xs text-[#8A8F97] mt-1 line-clamp-3 [&_a]:text-[#D4AF37] [&_strong]:text-current [&_b]:text-current" dangerouslySetInnerHTML={{ __html: n.text }} />
        </div>
      ))}
    </Card>
  );
}
